import { MoreVertIcon } from "@/Components/Icons/Icons";
import ActionCellRenderer from "@/Views/ExportJob/Dashboard/ActionCellRenderer";

const columns = [
  {
    id: "0",
    field: "customerName",
    headerName: "Name",
    label: "Name",
    minWidth: 350,
    maxWidth: 370,
    checked: true,
    sort: true,

  },
  {
    id: "1",
    field: "aliseName",
    headerName: "Alias",
    label: "Alias",
    minWidth: 400,
    maxWidth: 500,
    checked: true,
    sort: true,

  },

  {
    id: "2",
    field: "userTypes",
    headerName: "Entity Type",
    label: "Entity Type",
    minWidth: 500,
    maxWidth: 500,
    checked: true,
    sort: true,
  },
];

export default columns;
